routesConfig.$inject = ['$stateProvider']

function routesConfig($stateProvider) {
  $stateProvider
    .state('home.byLastItems', {
      url: "compra-rapida/carga-rapida-por-ultimos-items-comprados",
      template: `<by-last-items sh-ctrl="shCtrl"></by-last-items>`
    })
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/fast-purchase/by-last-items/by-last-items.config.js
 **/